<template>
    <div class="flex w-full flex-col gap-4 border-t border-gray-200 p-6">
        <h2 class="flex items-center gap-3 leading-6">
            <Icon :icon="IconDiscount" class="text-xl" :auto-align="false" />
            {{ $t('cart.promoCodes') }}
        </h2>
        <div :class="{ flex: inputVisible, hidden: !inputVisible }">
            <FormKit v-slot="{ state: { loading } }" type="form" form-class="w-full" :actions="false" @submit="addCode()">
                <div class="flex items-center justify-between gap-4">
                    <div class="relative w-full lg:grow">
                        <FormKit
                            v-model="discountCode"
                            type="text"
                            name="promoCode"
                            :disabled="loading"
                            :placeholder="t('cart.enterPromoCode')"
                            :classes="{
                                input: 'pr-10',
                                placeholder: 'font-bold text-lg'
                            }"
                        />
                    </div>
                    <FormKit
                        type="submit"
                        :inverted="true"
                        :tight="true"
                        name="checkPromo"
                        class="w-full"
                        :disabled="loading"
                        :ignore="false"
                        :classes="{
                            form: 'w-full',
                            input: {
                                'w-[6.875rem]': true,
                                'w-full': false
                            }
                        }">
                        {{ !loading ? $t('cart.checkCode') : '' }}
                    </FormKit>
                </div>
            </FormKit>
        </div>
        <div class="flex flex-col gap-3 text-xs">
            <div v-if="cart().cart.discounts.length && !cart().cartPricesValidated?.discounts?.find((discount: DiscountResponseCalculatorService) => discount.code === cart().cart.discounts[0])" class="relative flex w-full flex-col gap-1 rounded-md bg-red-100 p-3">
                <button v-if="cart().cart.discounts.includes(cart().cart.discounts[0])" class="absolute right-3 top-3 cursor-pointer text-xs" @click="cart().removeDiscountCode(cart().cart.discounts[0])">
                    <Icon :icon="IconClose" :auto-align="false" />
                </button>
                <span class="pr-9 font-bold">
                    Code: {{ cart().cart.discounts[0] }}
                </span>
                <span>{{ $t('cart.promoCodeInvalid') }}</span>
            </div>
            <template
                v-for="discount in cart().cartPricesValidated.discounts"
                :key="discount"
            >
                <div
                    class="relative flex w-full flex-col gap-1 rounded-md bg-green-100 p-3"
                >
                    <button v-if="cart().cart.discounts.includes(discount.code)" class="absolute right-3 top-3 cursor-pointer text-xs" @click="cart().removeDiscountCode(discount.code)">
                        <Icon :icon="IconClose" :auto-align="false" />
                    </button>
                    <span class="pr-9 font-bold">
                        <template v-if="cart().cart.discounts.includes(discount.code)">Code: {{ discount.code }}, </template>{{ $t('cart.discount') }}: {{ currencyFormat(discount?.amount) }}
                    </span>
                    <span>{{ discount?.label }}</span>
                </div>
            </template>
            <button class="flex items-center gap-2 text-sm font-bold text-primary" :class="{ hidden: inputVisible }" @click.prevent="showInput = true">
                <Icon :icon="IconPen" :auto-align="false" class="text-xxs" /> {{ $t('cart.addPromoCode') }}
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { DiscountResponseCalculatorService } from '~/types/calculator-service-types'
    import IconClose from '@/assets/icons/close.svg'
    import IconDiscount from '@/assets/icons/discount.svg'
    import IconPen from '@/assets/icons/pen.svg'
    import Icon from '~/components/Icon.vue'
    import { cart } from '~/store/cart'
    import { currencyFormat } from '~/utils/currency-utils'
    const { t } = useI18n()
    const discountCode = ref('')
    const showInput = ref(true)
    const inputVisible = computed(() => cart()?.cart?.discounts?.length === 0 || showInput.value)
    async function addCode () {
        showInput.value = false
        await cart().addDiscountCode(discountCode.value)
        discountCode.value = ''
    }
    onMounted(() => {
        if (cart()?.cart?.discounts?.length > 0) {
            showInput.value = false
        }
    })
</script>
